import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import { getItemLinkChildrenRecursively } from "@ext/item/logic/getItemLinkChildrenRecursively";
import { itemDeleteConfirm } from "@ext/item/logic/itemDeleteConfirm";
import { useRouter } from "../../../logic/Api/useRouter";
import FetchService from "../../../ui-logic/ApiServices/FetchService";
import { useCatalogPropsStore } from "../../../ui-logic/stores/CatalogPropsStore/CatalogPropsStore.provider";
import ErrorConfirmService from "../../errorHandlers/client/ErrorConfirmService";
import { shouldShowActionWarning } from "../../localization/actions/OtherLanguagesPresentWarning";
import NavigationEvents from "../../navigation/NavigationEvents";
import type { CategoryLink, ItemLink } from "../../navigation/NavigationLinks";
import DeleteItem from "./DeleteItem";

export const useDeleteItem = (itemLink: ItemLink) => {
	const apiUrlCreator = ApiUrlCreatorService.value;
	const supportedLanguagesLength = useCatalogPropsStore((state) => state.data?.supportedLanguages?.length);
	const router = useRouter();

	const confirmation = () => {
		const count = getItemLinkChildrenRecursively(itemLink as CategoryLink).length;
		return itemDeleteConfirm(itemLink.title, count, shouldShowActionWarning(supportedLanguagesLength));
	};

	const remove = async () => {
		ErrorConfirmService.stop();
		const res = await FetchService.fetch<{ redirectPath: string | null }>(
			apiUrlCreator.removeItem(itemLink.ref.path),
		);
		ErrorConfirmService.start();
		if (!res.ok) return;
		const { redirectPath } = await res.json();

		const mutable = { preventGoto: false };
		await NavigationEvents.emit("item-delete", { path: itemLink.pathname, mutable });
		if (mutable.preventGoto) return;

		if (redirectPath) await router.pushPath(redirectPath);
		else await refreshPage();
	};

	return { confirmation, remove };
};

export const DeleteItemTrigger = ({ itemLink }: { itemLink: ItemLink }) => {
	const { confirmation, remove } = useDeleteItem(itemLink);
	return <DeleteItem confirm={confirmation} onConfirm={remove} />;
};
